import { create } from 'zustand';

import type { PaginationProps } from 'antd';
import type { UgcReportSearchFormValues } from '@/pages/ugc-reports/utils';
import type { UgcReportTargetType, UgcReportTicket } from '@/services/ugc-reports';

export type UgcReportListCacheEntry = {
    searchFilters: UgcReportSearchFormValues;
    pagination: PaginationProps;
    expandedRowKeys: string[];
    dataSource: UgcReportTicket[];
};

type UgcReportListCacheStore = {
    entries: Partial<Record<UgcReportTargetType, UgcReportListCacheEntry>>;
    getEntry: (key: UgcReportTargetType) => UgcReportListCacheEntry | undefined;
    setEntry: (key: UgcReportTargetType, entry: UgcReportListCacheEntry) => void;
    clearEntry: (key: UgcReportTargetType) => void;
};

export const useUgcReportListCache = create<UgcReportListCacheStore>((set, get) => ({
    entries: {},
    getEntry: (key) => get().entries[key],
    setEntry: (key, entry) =>
        set((state) => ({
            entries: { ...state.entries, [key]: entry },
        })),
    clearEntry: (key) =>
        set((state) => {
            const nextEntries = { ...state.entries };
            delete nextEntries[key];
            return { entries: nextEntries };
        }),
}));
